/**
 * French calendar text (ADR 0093 §10). Same shape as the English file.
 * Weekdays and months are lowercase, as French writes them; the first of the
 * month is "1er". One day after or before is "le lendemain" or "la veille",
 * which is how French says it.
 *
 * Sunday first, as in English: these sheets serve North American classrooms,
 * as the French line plots' inches do (ADR 0093 §10).
 */
export const calendarText = {
    weekdays: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
    weekdaysShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
    weekdaysPlural: ['dimanches', 'lundis', 'mardis', 'mercredis', 'jeudis', 'vendredis', 'samedis'],
    months: [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre',
    ],
    ordinals: ['premier', 'deuxième', 'troisième', 'quatrième'],
    last: 'dernier',
    title: (month: string, year: number) => `${month.charAt(0).toUpperCase()}${month.slice(1)} ${year}`,
    date: (month: string, day: number) => `${day === 1 ? '1er' : day} ${month}`,
};

export const calendarPrompts = {
    dayOfWeek: (date: string) => `Quel jour de la semaine est le ${date} ?`,
    findDate: (ordinal: string, weekday: string) => `Quelle est la date du ${ordinal} ${weekday} ?`,
    howManyWeekday: (weekdays: string, month: string) => `Combien y a-t-il de ${weekdays} en ${month} ?`,
    howManyDays: (month: string) => `Combien de jours y a-t-il en ${month} ?`,
    beforeAfter: (count: number, weeks: boolean, after: boolean, date: string) => {
        if (count === 1 && !weeks) {
            return after ? `Quelle date tombe le lendemain du ${date} ?` : `Quelle date tombe la veille du ${date} ?`;
        }
        const unit = weeks ? (count === 1 ? 'semaine' : 'semaines') : 'jours';
        return `Quelle date tombe ${count} ${unit} ${after ? 'après' : 'avant'} le ${date} ?`;
    },
};
